(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) {
      if (el.dataset.mtRevealInit) return;
      el.dataset.mtRevealInit = '1';
      obs.observe(el);
    });
  }

  function initContadores() {
    var els = document.querySelectorAll('[data-mt-contador]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        if (el.dataset.mtCounted) return;
        el.dataset.mtCounted = '1';
        var target = parseFloat(el.getAttribute('data-mt-contador')) || 0;
        var decimals = (el.getAttribute('data-mt-contador').split('.')[1] || '').length;
        var suffix = el.getAttribute('data-mt-sufijo') || '';
        var dur = 1400;
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = target * eased;
          el.textContent = val.toFixed(decimals) + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        obs.unobserve(el);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) {
      if (el.dataset.mtInit) return;
      el.dataset.mtInit = '1';
      obs.observe(el);
    });
  }

  function initFAQ() {
    var items = document.querySelectorAll('.mt-faq-item');
    items.forEach(function (item) {
      if (item.dataset.mtInit) return;
      item.dataset.mtInit = '1';
      var btn = item.querySelector('.mt-faq-pregunta');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var abierto = item.classList.contains('mt-faq-abierto');
        item.parentElement.querySelectorAll('.mt-faq-item').forEach(function (i) {
          i.classList.remove('mt-faq-abierto');
        });
        if (!abierto) item.classList.add('mt-faq-abierto');
      });
    });
  }

  function initBento() {
    var cards = document.querySelectorAll('.mt-bento-card');
    cards.forEach(function (card) {
      if (card.dataset.mtInit) return;
      card.dataset.mtInit = '1';
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        card.style.setProperty('--mt-x', (e.clientX - r.left) + 'px');
        card.style.setProperty('--mt-y', (e.clientY - r.top) + 'px');
      });
    });
  }

  function initTodo() {
    initReveal();
    initContadores();
    initFAQ();
    initBento();
  }

  document.addEventListener('DOMContentLoaded', initTodo);
  document.addEventListener('shopify:section:load', initTodo);
})();
